import { ruleSlope } from './rules/slope';
import { ruleRunLength } from './rules/runLength';
import { ruleLandings } from './rules/landings';
import { ruleRails } from './rules/rails';
import { ruleHandrails } from './rules/handrails';
import { ruleWidth } from './rules/width';
import { ruleWidthCommercial } from './rules/width-commercial';
import { ruleClearSpace } from './rules/clearSpace';
import { ruleCommercialFloor } from './rules/commercialFloor';
import { ruleProductExists } from './rules/productExists';
import { Rule, ValidateResult } from './types';
import { Submission } from '@gorampe/calc-engine';
import { Catalog } from '@gorampe/catalog-adapter';

const ALL_RULES: Rule[] = [
  ruleSlope,
  ruleRunLength,
  ruleLandings,
  ruleRails,
  ruleHandrails,
  ruleWidth,
  ruleWidthCommercial,
  ruleClearSpace,
  ruleCommercialFloor,
  ruleProductExists,
];

export function validate(submission: Submission, catalog: Catalog): ValidateResult {
  const result: ValidateResult = { warnings: [], errors: [], infos: [] };
  for (const rule of ALL_RULES) {
    const r = rule(submission, catalog);
    if (!r) continue;
    if (r.severity === 'error') result.errors.push(r);
    else if (r.severity === 'warn') result.warnings.push(r);
    else result.infos.push(r);
  }
  return result;
}

export * from './types';
